import { render, staticRenderFns } from "./LegalInfoLink.vue?vue&type=template&id=4259dca3&"
import script from "./LegalInfoLink.vue?vue&type=script&lang=js&"
export * from "./LegalInfoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports